import React from 'react';

const NotFoundPage = () => {
  return <div>404 / No stuff here</div>;
};

export default NotFoundPage;
